import { useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'hosty_sunmi_pda_banner_dismissed';

function readDismissed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function SunmiAnnouncementBanner() {
  const [dismissed, setDismissed] = useState(readDismissed);

  if (dismissed) {
    return null;
  }

  function handleDismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // Si localStorage no está disponible, el aviso volverá en la próxima visita.
    }
    setDismissed(true);
  }

  return (
    <aside className="announcement-banner announcement-banner--sunmi" aria-label="Nuevo terminal Sunmi">
      <div className="container announcement-banner__inner">
        <span className="announcement-banner__device" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <rect x="5.5" y="2.5" width="13" height="19" rx="3" stroke="currentColor" strokeWidth="1.8" />
            <path d="M8.5 6.5h7M8.5 10h7M9 17h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            <circle cx="12" cy="14" r="1.2" fill="currentColor" />
          </svg>
        </span>

        <p className="announcement-banner__text">
          <span className="announcement-banner__label">Nuevo</span>
          <strong>PDA Sunmi: pedidos y cobros desde un mismo terminal.</strong>
        </p>

        <Link to="/contacto" className="announcement-banner__cta">
          Consultar el terminal
          <span aria-hidden="true">→</span>
        </Link>

        <button
          type="button"
          className="announcement-banner__close"
          onClick={handleDismiss}
          aria-label="Cerrar anuncio del terminal Sunmi"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </aside>
  );
}
